import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import useToast from '../../../helpers/useToast';
import { 
    postLocationQuestion, 
    getAvailableCustomVariables } from '../../../api/typeFormQuestionApi';

const AdminLocationQuestionModal = ({ open, handleClose, refresh }) => {
  const toastOption = useToast();
  const [search, setSearch] = useState("");
  const [variables, setVariables] = useState([]);

  const loadVariables = async () => {
    try {
      const res = await getAvailableCustomVariables();
      setVariables(res.data.data || []);
    } catch (err) {
      toast.error("Failed to load variables", toastOption);
    }
  };

  useEffect(() => {
    if (open) loadVariables();
  }, [open]);

  const handleSelect = async (id) => {
    try {
      const body = { questionId: id };
      const res = await postLocationQuestion(body);

      toast.success(res.data.message || "Added!", toastOption);
      refresh();
      handleClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed!", toastOption);
    }
  };

  return (
    <Dialog
    open={open}
    onClose={handleClose}
    maxWidth="md"   
    fullWidth      
    PaperProps={{
      style: {
        height: "80vh", 
        borderRadius: "12px",
      },
    }}
  >
    <div className="d-flex align-items-center justify-content-between">
      <DialogTitle>Select Custom Variable</DialogTitle>

      <IconButton aria-label="close" onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </div>

    <DialogContent dividers style={{ height: "100%", padding: "20px" }}>
      
      {/* Search Input */}
      <TextField
        label="Search Variable"
        variant="outlined"
        size="small"
        className="w-100 mb-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Scrollable List */}
      <div style={{
        maxHeight: "65vh",
        overflowY: "auto",
        paddingRight: "5px"
      }}>
        {variables
          .filter((v) =>
            v.customVariable.toLowerCase().includes(search.toLowerCase())
          )
          .map((v) => (
            <div
              key={v._id}
              onClick={() => handleSelect(v._id)}
              style={{
                padding: "14px 12px",
                marginBottom: "10px",
                borderRadius: "8px",
                cursor: "pointer",
                border: "1px solid #d7d7d7",
                background: "#fafafa",
                transition: "0.2s",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#eaeaea";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "#fafafa";
              }}
            >
              <strong>{v.customVariable}</strong>
            </div>
          ))}

        {variables.length === 0 && (
          <p className="text-center text-muted mt-3">No variables available</p>
        )}
      </div>
    </DialogContent>
  </Dialog>
  );
};

export default AdminLocationQuestionModal;
